export const routes = {
    dashboard: '/dashboard',
    scenario: (slug) => {
        return slug ? `/scenario/${slug}` : '/scenario/:slug';
    },
    scenarios: '/scenarios',
    history: '/history',
    video: (requestId) => {
        return requestId ? `/video/${requestId}` : '/video/:requestId';
    },
    interactions: '/interactions',
    reports: '/',
    users: '/users',
    settings: '/settings',
    logging: '/logging',
    login: '/login',
    reset: '/reset',
}
